import {AbstractControl, FormControl, FormGroup, ValidatorFn} from '@angular/forms';

export class CustomsValidationDirective {
    // check mismatch password - passConfirm
    // output: object err or null
    static MatchPassword(AC: AbstractControl) {
        let password = AC.get('password').value;
        let passConfirm = AC.get('passConfirm').value;

        if (password.indexOf(' ') >= 0 || passConfirm.indexOf(' ') >= 0) {
            AC.get('passConfirm').setErrors({noWhiteSpace: true});
        } else if (AC.get('password').invalid && password.trim() < 6 || password.trim() != passConfirm.trim()) {
            AC.get('passConfirm').setErrors({mismatchPassword: true});
        } else {
            if (!AC.get('password').invalid) {
                AC.get('passConfirm').setErrors(null);
            }

            return null
        }
    }

    // check field in formGroup
    // output: object err or null
    static validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({onlySelf: true});
            } else if (control instanceof FormGroup) {
                CustomsValidationDirective.validateAllFormFields(control);
            }
        });
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_directives/customs-validation.directive.ts